import AgentMessage from './message_agent';
import UserMessage from './message_user';
import InputRequestedMessage from './message_input_requested';
import SystemMessage from './message_tool';
import WorkflowEndMessage from './message_workflow_end';
import { AGENT_MESSAGE_TYPE, FLOW_END_TYPE, INPUT_REQUEST_TYPE, TOOL_MESSAGE_TYPE, USER_MESSAGE_TYPE } from './constants';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

const DEFAULT_COMPONENT_MAP = {
  [AGENT_MESSAGE_TYPE]: AgentMessage,
  [FLOW_END_TYPE]: WorkflowEndMessage,
  [INPUT_REQUEST_TYPE]: InputRequestedMessage,
  [TOOL_MESSAGE_TYPE]: SystemMessage,
  [USER_MESSAGE_TYPE]: UserMessage
};
var script = {
  name: 'MessageMap',
  props: {
    /**
     * The message object containing the message data
     */
    message: {
      type: Object,
      required: true,
      validator(message) {
        return message.message_type;
      }
    },
    /**
     * Optional custom component map to override or add default message components
     */
    componentMap: {
      type: Object,
      required: false,
      default() {
        return {};
      }
    }
  },
  computed: {
    messageMap() {
      return {
        ...DEFAULT_COMPONENT_MAP,
        ...this.componentMap
      };
    },
    messageComponent() {
      var _this$message;
      return this.isValidMessageType ? this.messageMap[(_this$message = this.message) === null || _this$message === void 0 ? void 0 : _this$message.message_type] : AgentMessage;
    },
    validMessageTypes() {
      return [...Object.keys(DEFAULT_COMPONENT_MAP), ...Object.keys(this.componentMap)];
    },
    isValidMessageType() {
      var _this$message2;
      return this.validMessageTypes.includes((_this$message2 = this.message) === null || _this$message2 === void 0 ? void 0 : _this$message2.message_type);
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.messageComponent,_vm._g(_vm._b({tag:"component",attrs:{"message":_vm.message}},'component',_vm.$attrs,false),_vm.$listeners))};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
